// extracted by mini-css-extract-plugin
module.exports = {"tag":"style_tag__2_H1k"};